// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2hRiR","buttons":"PendingPaymentAlert_buttons__2T0k6"};